module.exports = __webpack_public_path__ + "static/media/logBatteryActive.f509fff4.svg";